/**
 * Turn any common YouTube link into a privacy-friendly embed URL.
 *
 * Accepts watch (`?v=`), short (`youtu.be/`), `embed/`, `shorts/`, `live/`
 * links, or a bare 11-character video id. Returns null when nothing usable is
 * found, so callers can show a "not a valid link" hint instead of a broken
 * iframe.
 */
const ID = '([A-Za-z0-9_-]{11})';

const PATTERNS: RegExp[] = [
  new RegExp(`youtube\\.com/watch\\?[^#]*\\bv=${ID}`),
  new RegExp(`youtu\\.be/${ID}`),
  new RegExp(`youtube\\.com/embed/${ID}`),
  new RegExp(`youtube\\.com/shorts/${ID}`),
  new RegExp(`youtube\\.com/live/${ID}`),
];

/** Extract the 11-character YouTube video id from a link, or null. */
export function youtubeVideoId(input: string | null | undefined): string | null {
  if (!input) return null;
  const url = input.trim();
  for (const pattern of PATTERNS) {
    const match = url.match(pattern);
    if (match?.[1]) return match[1];
  }
  if (/^[A-Za-z0-9_-]{11}$/.test(url)) return url;
  return null;
}

/** Build the embeddable URL for a YouTube link, or null when unrecognised. */
export function youtubeEmbedUrl(input: string | null | undefined): string | null {
  const id = youtubeVideoId(input);
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
}
